import React from "react";
import browseSlider from "../data/browseSlider.json";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import BrowseSearch from "./BrowseSearch";

function Header() {
  return (
    <div className="mt-[50px] relative overflow-hidden pb-32 ">
      <div>
        <div className="relative">
          {browseSlider.map((image) => (
            <div
              key={image.key}
              className=" h-[450px] w-full pointer-events-none"
            >
              <div className="h-[250px] overflow-hidden w-full absolute">
                <img
                  fetchpriority="high"
                  className="clipPath object-cover w-full h-[250px] lg:h-[450px] objectPosition object-center absolute"
                  src={`https://img.gs/bfcwxjcwhk/full,quality=medium/https://eyenovel.netlify.app/${image.image}`}
                  // srcSet={`${image.image} 640w, ${image.image} 750w, ${image.image} 828w, ${image.image} 1080w,${image.image} 1200w, ${image.image} 1920w, ${image.image} 2048w, ${image.image} 3840w`}
                  alt="images"
                />
              </div>
              <div className="h-[450px] w-full z-20 md:z-10 absolute">
                <img
                  fetchpriority="high"
                  src={`https://img.gs/bfcwxjcwhk/full,quality=medium/https://eyenovel.netlify.app/${image.image2}`}
                  className="clipPath object-cover w-full object-center h-[250px] lg:h-[450px] objectPosition"
                  width="100%"
                  sizes="100vw"
                  alt="images"
                />
              </div>
            </div>
          ))}
        </div>
        <div className="relative z-10">
          <BrowseSearch />
        </div>
      </div>
    </div>
  );
}

export default Header;
